import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import { ButtonGroup, styled } from '@mui/material';
import { transparentize } from 'polished';
import { palette } from '../../theme';

export const StyledButtonGroup = styled(ButtonGroup)(() => ({
  margin: 8,
  width: 'auto',
  display: 'inline-flex',
  position: 'relative',
  borderRadius: 4,
  overflow: 'hidden',
  flexShrink: 0,
  '& > .MuiButtonGroup-grouped:not(:last-of-type)': {
    flex: 1,
    minWidth: 0,
  },
}));

export const StyledButton = styled(LoadingButton)<LoadingButtonProps>(
  ({ theme, color = 'primary' }) => {
    const paletteColor = color && color !== 'inherit'
      ? theme.palette[color]
      : theme.palette.primary;

    return {
      height: 35,
      '& .MuiLoadingButton-loadingIndicator': {
        color: transparentize(0.4, palette.background.main),
      },
      '&:disabled': {
        backgroundColor: paletteColor.main,
        color: paletteColor.contrastText,
      },
    };
  },
);